import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"

export interface SplitGroupingValue {
  retailer: boolean
  productLine: boolean
  executionDate: boolean
  adminFee: boolean
}

export interface SplitGroupingOptionsProps {
  value: SplitGroupingValue
  onChange: (value: SplitGroupingValue) => void
  className?: string
}

export function SplitGroupingOptions({ value, onChange, className }: SplitGroupingOptionsProps) {
  return (
    <div class={`space-y-3 ${className ?? ""}`}>
      <Label class="text-sm font-medium">Group lines by:</Label>
      <div class="space-y-2">
        <SplitGroupingCheckbox
          id="split-group-retailer"
          label="Retailer"
          checked={value.retailer}
          onChange={(checked) => onChange({ ...value, retailer: checked })}
        />
        <SplitGroupingCheckbox
          id="split-group-product-line"
          label="Product Line"
          checked={value.productLine}
          onChange={(checked) => onChange({ ...value, productLine: checked })}
        />
        <SplitGroupingCheckbox
          id="split-group-execution-date"
          label="Execution Date"
          checked={value.executionDate}
          onChange={(checked) => onChange({ ...value, executionDate: checked })}
        />
        <SplitGroupingCheckbox
          id="split-group-admin-fee"
          label="Admin Fee"
          checked={value.adminFee}
          onChange={(checked) => onChange({ ...value, adminFee: checked })}
        />
      </div>
    </div>
  )
}

interface SplitGroupingCheckboxProps {
  id: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

function SplitGroupingCheckbox({ id, label, checked, onChange }: SplitGroupingCheckboxProps) {
  return (
    <div class="flex items-center space-x-2">
      <Checkbox id={id} checked={checked} onCheckedChange={onChange} />
      <Label htmlFor={id} class="text-sm font-normal cursor-pointer">
        {label}
      </Label>
    </div>
  )
}

export function split_grouping_value_from_prefs(prefs: {
  split_by_retailer: boolean
  split_by_product_line: boolean
  split_by_execution_date: boolean
  split_by_admin_fee: boolean
}): SplitGroupingValue {
  return {
    retailer: prefs.split_by_retailer,
    productLine: prefs.split_by_product_line,
    executionDate: prefs.split_by_execution_date,
    adminFee: prefs.split_by_admin_fee,
  }
}

export function prefs_from_split_grouping_value(
  split_into_multiple_lines: boolean,
  value: SplitGroupingValue
): {
  split_into_multiple_lines: boolean
  split_by_retailer: boolean
  split_by_product_line: boolean
  split_by_execution_date: boolean
  split_by_admin_fee: boolean
} {
  return {
    split_into_multiple_lines,
    split_by_retailer: value.retailer,
    split_by_product_line: value.productLine,
    split_by_execution_date: value.executionDate,
    split_by_admin_fee: value.adminFee,
  }
}
